const Config = {
    hostname: "https://api.aldvindevelopment.com"
}

export default Config;